import { useState, useCallback } from "react";

export type DialogType = "conversation" | "agent" | "document" | "expanded";

interface DialogState {
  conversation: boolean;
  agent: boolean;
  document: boolean;
  expanded: boolean;
}

interface SelectedData {
  conversation: any | null;
  agent: any | null;
  document: any | null;
}

/**
 * Hook to manage activity card dialog state
 * Ensures dialogs and selected data stay in sync
 */
export function useActivityDialog() {
  const [dialogs, setDialogs] = useState<DialogState>({
    conversation: false,
    agent: false,
    document: false,
    expanded: false,
  });

  const [selected, setSelected] = useState<SelectedData>({
    conversation: null,
    agent: null,
    document: null,
  });

  const openDialog = useCallback(
    (type: DialogType, data: any = null) => {
      setDialogs((prev) => ({ ...prev, [type]: true }));
      if (type !== "expanded" && data) {
        setSelected((prev) => ({ ...prev, [type]: data }));
      }
    },
    []
  );

  const closeDialog = useCallback((type: DialogType) => {
    setDialogs((prev) => ({ ...prev, [type]: false }));
    if (type !== "expanded") {
      setSelected((prev) => ({ ...prev, [type]: null }));
    }
  }, []);

  const toggleExpanded = useCallback(() => {
    setDialogs((prev) => ({ ...prev, expanded: !prev.expanded }));
  }, []);

  return {
    dialogs,
    selected,
    openDialog,
    closeDialog,
    toggleExpanded,
  };
}
